<template>
  <div />
</template>

<script>
export default {
  name: 'Home'
}
</script>
